import React from "react";
import { ToastContainer } from "react-toastify";
import { ModalProvider } from "./components/modal/Modal.component";
import { AppComponent } from "./components/app/App.component";
import "./styles/styles.scss";
import { createRenderer } from "./three/createRenderer";
import { MenuProvider } from "./components/menu/useMenu";
import { createRoot } from "react-dom/client";

const container = document.getElementById("mainBody");
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <MenuProvider>
      <ModalProvider>
        <AppComponent />
      </ModalProvider>
    </MenuProvider>
    <ToastContainer />
  </React.StrictMode>,
);

export const renderer = createRenderer();
